export default __webpack_public_path__ + "static/media/right-arrow-dashboard.4c317f8d.svg";